import { all, takeLatest, call, put } from 'redux-saga/effects';
import i18next from 'i18next';
import { Url } from '@wix/da-url';
import { PapiDaSignupSigninSigninSocial } from '@wix/da-papi-types';
import { isApiError, requestPuppy, XhrResponse } from '@wix/da-http-client';
import { setCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/actions';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { addErrorNotification } from '../../Notifications/redux/actionCreators';
import { setSocialLoginError, attemptSocialLogin, socialLoginSuccess } from './actions';

function getSocialLoginErrorMessage(errorCode: string | undefined): string {
  const primaryKey =
    errorCode && errorCode.length > 0
      ? `join.error.social.${errorCode}`
      : 'join.error.social.general';
  return i18next.t([primaryKey, 'join.error.social.general']);
}

function* handleLogin(action: ReturnType<typeof attemptSocialLogin>) {
  const { provider, token, redirectToJoin, redirectToSisu } = action.payload;
  const response: XhrResponse<PapiDaSignupSigninSigninSocial> = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/signin_social',
      data: {
        provider,
        provider_token: token,
        remember: true,
      },
    },
    undefined,
    'dasignupsignin'
  );

  if (!response || isApiError(response)) {
    if (redirectToSisu) {
      yield put(addErrorNotification(getSocialLoginErrorMessage('general')));
    } else {
      yield put(setSocialLoginError('general'));
    }
    return;
  }
  const errors = response.errors ?? [];
  if (!response.success || errors.length > 0) {
    const errorKey = errors.length > 0 ? errors[0] : '';
    if (redirectToSisu) {
      yield put(addErrorNotification(getSocialLoginErrorMessage(errorKey)));
    } else {
      yield put(setSocialLoginError(errorKey));
    }
    return;
  }

  yield put(setSocialLoginError(undefined));

  if (redirectToSisu) {
    if (response.loggedin) {
      window.location.assign(Url.browseHomeLink());
      return;
    }
    yield put(
      setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.SOCIAL,
        value: `${provider}:${response.tokenId ?? ''}`,
      })
    );
    window.location.assign(Url.joinLink());
    return;
  }

  yield put(
    socialLoginSuccess({
      provider,
      response,
      redirectToJoin,
    })
  );
}

export default function* socialSaga() {
  yield all([takeLatest(attemptSocialLogin, handleLogin)]);
}
